"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";

type OrderCardContentProps = {
  className?: string;
  topSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
  reverse?: boolean;
} & React.ComponentProps<"div">;

export const OrderCardContent = memo(
  ({
    className,
    topSlot,
    bottomSlot,
    reverse = false,
    children,
  }: OrderCardContentProps) => {
    return (
      <div
        className={cn(
          "rounded-xl border border-border-default bg-background-secondary text-semantic-text-primary p-4 md:p-0 md:rounded-3xl",
          className
        )}
      >
        <div className="grid grid-cols-1 place-content-start gap-6 [&>div]:not-last:pb-6 divide-y divide-light-gray w-full md:grid-cols-[minmax(0,39fr)_minmax(0,55fr)] md:grid-rows-[minmax(0,auto)_minmax(0,1fr)] md:gap-x-0 md:gap-y-6 md:divide-y-0">
          <div
            className={cn(
              "grid grid-cols-1 place-items-start gap-4 w-full md:py-6 md:px-8",
              {
                "md:row-span-2 md:border-r md:border-r-border-default": reverse,
              }
            )}
          >
            <div className="grid grid-cols-1 place-items-start gap-4 w-full">
              {topSlot}
            </div>
          </div>

          <div
            className={cn(
              "grid grid-cols-1 place-items-start gap-4 pb-4 [&>div]:not-last:pb-4 md:gap-6 md:pb-6 md:[&>div]:not-last:pb-6 divide-y divide-light-gray w-full md:py-6 md:px-8",
              {
                "md:row-span-2 md:border-l md:border-l-border-default":
                  !reverse,
              }
            )}
          >
            {children}
          </div>

          <div className="flex items-end md:px-8 md:pb-6">
            <div
              className={cn("md:pt-6", {
                "md:border-t md:border-t-border-default": reverse,
              })}
            >
              {bottomSlot}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default OrderCardContent;
